import FullText from './FullText.js';

export default FullText;